import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "react-redux";
import { patientActions } from "../../core/actions";
import { format, parse } from "date-fns";
import { AADHAAR_MANDATORY_ORGS, DOCTOR_ROLE } from "../../shared/constants";
import { helperServices } from "../../shared/helper";
import { useOrganization } from "../../configurations/OrganizationContext";
import { isAadhaarMandatoryForOnboarding } from "../../configurations/aadhaarConfig";
import personDetailsService from "../../core/services/personDetailsService";
import Autocomplete from "@mui/material/Autocomplete";
import {
  Grid,
  TextField,
  FormControlLabel,
  Radio,
  RadioGroup,
  InputLabel,
  FormControl,
  Select,
  FormGroup,
  Checkbox,
  Card,
} from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CardBody from "@material-ui/core/CardContent";
import CardImg from "@material-ui/core/CardMedia";
import CardMedia from "@material-ui/core/CardMedia";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Box from "@material-ui/core/Box";
import { Alert } from "@mui/material";
import Webcam from "react-webcam";
import Components from "./index";
import { useBarcode } from "react-barcodes";
import ProcedureListing from "./ProcedureListing";
import doctorActions, {
  getDepartmentList,
} from "./../../core/actions/doctorActions";
import useDynamicFontFormatter from "../../shared/helper/useDynamicFontFormatter";
import {
ORG_CODES
} from "../../shared/constants";

export const getEffectivePatientType = (info) => {
  if (!info) return "OutPatient";
  const flag = (
    info?.visitflag ||
    info?.visit?.visitflag ||
    ""
  ).toLowerCase();
  if (flag === "walkin") return "Walkin";
  if (flag === "proxy") return "Proxy";
  if (flag === "other") return "Other";
  return info?.type || "OutPatient";
};


function PatientForm(props) {
  const radioRefs = useRef([]);
  const org = useOrganization();
  const formatText = useDynamicFontFormatter(org?.fontStyle);

  let videoRef = useRef(null);
  let photoRef = useRef(null);
  const [patientDetail, setPatientDetail] = useState({
    id: "",
    patientId: "",
    fname: "",
    mname: "",
    lname: "",
    age: "",
    adhar: "",
    phno: "",
    area: "",
    city: formatText(org?.address) || "Mangaluru",
    state: formatText(org?.state) || "Karnataka",
    pincode: "",
    gender: "",
    bloodgroup: "",
    occupation: "",
    address: "",
    dob: "",
    age: "",
    email: "",
    imgUrl: "",
    udt: "",
    visit: {
      reference: {
        refkey: "",
        refby: "",
      },
      referenceId: "",
      visitflag: "",
    },
    upload: {},
    type:
      props?.patientInfo && !Array.isArray(props.patientInfo)
        ? getEffectivePatientType(props.patientInfo)
        : "OutPatient",
    insurance: "",
    fileNo: "",
    srcRef: "",
    language: "",
    education: "",
    sociostatus: "",
    tokenNumber: "",
    deskNo: "",
    comments: "",
    status: "",
    ehrid: "",
    erpCustId: "",
    altPhno: "",
    emrPhono: "",
    iStatus: "",
    custGroupId: "G",
    custGrpDesc: "General Customer",
    mothern: "",
    fathern: "",
    fathernorspouse: "",
    checkAdharUpdate: "NO",
    maskAdhar: "",
    department: "",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    type: false,
  });
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [formErrors, setFormErrors] = useState({
    fname: "",
    phno: "",
    age: "",
    dob: "",
    adhar: "",
    email: "",
    city: "",
    state: "",
    emrPhono: "",
  });
  const [imagSrc, setimagSrc] = React.useState(null);
  const [uploadFile, setUploadFile] = useState({
    id: "",
    patientId: "",
    name: "",
    phno: "",
    imgurl: "",
    type: "",
    file: "",
  });
  const [imgSrc, setImgSrc] = useState(null);
  const [showWebCam, setShowWebCam] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [submitted, setSubmitted] = useState([]);
  const [patientData, setPatientData] = useState([]);
  const [callType, setCallType] = useState([]);
  const [showWebCamModal, setShowWebCamModal] = useState(false);
  const [printTOkenModal, setPrintTOkenModal] = useState(false);
  const [modalopen, setModalopen] = useState(false);

  const [videoConstraintsSelfie, setVideoConstraintsSelfie] = useState({
    width: 220,
    height: 200,
    facingMode: "user",
  });
  const [videoConstraints, setVideoConstraints] = useState({
    facingMode: { exact: "environment" },
  });
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const dispatch = useDispatch();

  const [barcodeNo, setbarcodeNo] = useState();

  //const webcamRef = React.createRef();
  const webcamRef = React.useRef(null);
  //this.capture = this.capture.bind(this);
  const patient = useSelector((state) => state.patientDetailsState.patient);
  const [viewBasicInfo, setviewBasicInfo] = useState(false);
  const [reload, setReload] = useState(false);
  const [selectedGender, setSelectedGender] = useState("");
  var d = new Date();
  // const todayDate = format(d.setDate(d.getDate()), "yyyy-MM-dd");
  const todayDate = new Date().toISOString().split("T")[0];
  //const length = patientDetail.age.length < 11;
  const [convertModal, setconvertModal] = useState(false);
  const [editProfile, setEdiProfile] = useState(props.openPatientForm);

  const todayDate1 = format(new Date(), "yyyy-MM-dd");

  // Get the current time and format it as "HH:mm" for the time input field
  const currentTime = format(new Date(), "HH:mm");

  // Set the default values
  const [selecteddate, setSelecteddate] = useState(todayDate1);
  const [selectedTime, setSelectedTime] = useState(currentTime);
  const [customerGroup, setCustomerGroup] = useState([]);
  const [showparentnames, setShowparentnames] = useState(false);
  const [department, setDepartment] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [docList, setDocList] = useState([]);
  const noFormatFields = [
    "department",
    "email",
    "type",
    "insurance",
    "bloodgroup",
    "custGroupId",
    "custGrpDesc",
    "gender",
  ];

  useEffect(() => {
    console.log("patientFormDetail in patient form : ", patient);
    console.log("props patient form : ", props);
    if (
      props &&
      props.patientInfo &&
      props.patientInfo.admsnDate &&
      props.patientInfo.admsnDate !== ""
    ) {
      const admissionDate = parse(
        props.patientInfo.admsnDate,
        "MMM dd yyyy HH:mm",
        new Date(),
      );
      const formattedDate = format(admissionDate, "yyyy-MM-dd");
      const formattedTime = format(admissionDate, "HH:mm");
      setSelecteddate(formattedDate);
      setSelectedTime(formattedTime);
    }
    getCustomerGroupInfo();
    getDepartmentList();
    getDoctorList();
    const pData = Array.isArray(patient) && patient.length > 0 ? patient[0] : null;
    if (pData) {
      setPatientDetail({
        ...pData,
        type: getEffectivePatientType(pData),
      });
    } else {
      if (
        props &&
        props.patientInfo &&
        (!Array.isArray(props.patientInfo) || props.patientInfo.length > 0)
      ) {
        const info = Array.isArray(props.patientInfo)
          ? props.patientInfo[0]
          : props.patientInfo;
        if (props.isDependent) {
          const motherName = info?.fname || "";
          const today = new Date().toISOString().slice(0, 10);
          setPatientDetail({
            ...info,
            mothern: motherName,
            fname: `Baby_of_${motherName}`,
            age: 0,
            gender: "",
            dob: today,
            adhar: "000000000000",
            insurance: "",
            mname: "",
            lname: "",
            fathern: "",
            fathernorspouse: "",
            department: info?.department || "",
            type: getEffectivePatientType(info),
          });
        } else {
          console.log(
            "props.patientInfo",
            info.adhar,
            info.maskAdhar,
          );
          setPatientDetail({
            ...info,
            adhar: info.adhar,
            maskAdhar: info.maskAdhar,
            type: getEffectivePatientType(info),
          });
          console.log(
            "checkkk",
            info.department,
            info,
            info.visit,
          );
          if (info.mothern && info.mothern != "") {
            setShowparentnames(true);
          }
        }
      }
    }

    const isEditMode =
      (props.patientInfo &&
        !Array.isArray(props.patientInfo) &&
        (props.patientInfo.id || props.patientInfo.patientId)) ||
      (patient &&
        !Array.isArray(patient) &&
        (patient.id || patient.patientId)) ||
      (Array.isArray(patient) && patient.length > 0);

    if (!isEditMode) {
      setCallType("Add");
      setviewBasicInfo(false);
      setSelectedGender(props.patientInfo?.gender || "");
    } else {
      setCallType("Edit");
      setviewBasicInfo(true);
      const gender =
        props.patientInfo?.gender ||
        (Array.isArray(patient) ? patient[0]?.gender : patient?.gender) ||
        "";
      setSelectedGender(gender);
      if (props.isDependent) {
        setSelectedGender(patientDetail.gender);
      }
    }
    setReload(!reload);
    console.log("callType", callType);
    console.log("patientDetail:", patientDetail);
  }, [props]);

  const getDoctorList = () => {
    const resCb = personDetailsService.getDoctorsDetail();
    if (resCb) {
      let list = [];
      for (let doc of resCb) {
        if (doc != null) {
          console.log("DocList", resCb);
          if (doc.type?.toLowerCase() === "doctor") {
            let opt = helperServices.buildDoctorOption(doc);
            list.push(opt);
          }
        }
      }
      setDocList([...list]);
    }
  };

  const getCustomerGroupInfo = () => {
    dispatch(
      patientActions.getCustomerGroupInfo((resCb) => {
        if (resCb) {
          setCustomerGroup(resCb?.customerGroupInfo);
        }
      }),
    );
  };

  const getDepartmentList = (data) => {
    dispatch(
      doctorActions.getDepartmentList(data, (resCb) => {
        if (resCb) {
          let deptlist = [];
          for (let dept of resCb) {
            let deptopt = {};
            deptopt["id"] = dept.id;
            deptopt["name"] = dept.name;
            deptlist.push(deptopt);
          }
          setDepartment([...deptlist]);
        }
      }),
    );
  };

  const handleOnChange = (value, event) => {
    if (value === "date") {
      setSelecteddate(event.target.value);
      console.log("Seleected Date is", event.target.value, event);
      console.log("Seleected Date is", typeof selecteddate);
    }
    if (value === "time") {
      setSelectedTime(event.target.value);
      console.log("Seleected Date is", event.target.value, event);
      console.log("Seleected Date is", typeof selectedTime);
    }
  };
  // const isEmail = (email) =>
  //   /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

  const handleKeyDown = (e) => {
    const invalidKeys = ["e", "E", "+", "-", "."];
    if (invalidKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleInputChange = (name, value) => {
    let pDetail = { ...patientDetail };
    if (name === "type") {
      if (value === "Other" && org?.orgCode === ORG_CODES.MNH) {
        setFormErrors({
          fname: "",
          phno: "",
          age: "",
          dob: "",
          adhar: "",
          email: "",
          city: "",
          state: "",
          emrPhono: "",
          gender: "",
        });
        pDetail.visit = pDetail.visit || {};
        pDetail.visit.visitflag = "Other";
        pDetail.visitflag = "Other";
      } else if (value === "Walkin") {
        pDetail.visit = pDetail.visit || {};
        pDetail.visit.visitflag = "Walkin";
        pDetail.visitflag = "Walkin";
      } else if (value === "Proxy") {
        pDetail.visit = pDetail.visit || {};
        pDetail.visit.visitflag = "Proxy";
        pDetail.visitflag = "Proxy";
      } else {
        pDetail.visitflag = null;
        if (pDetail.visit) {
          pDetail.visit.visitflag = null;
        }
      }
    }
    formErrors[name] = "";
    if (
      name === "type" &&
      !isAadhaarMandatoryForOnboarding(org, value)
    ) {
      formErrors.adhar = "";
    }
    console.log("In handleInputChange", name, value);

    if (name === "adhar") {
      pDetail.checkAdharUpdate = "YES";
    }

    // AGE validation
    if (name === "age") {
      if (/^(\d+(\.\d*)?|\.\d*)?$/.test(value)) {
        let correctedValue = value;
        if (value === ".") correctedValue = "0";
        else if (/^\.\d+$/.test(value)) correctedValue = "0" + value;
        else if (/^\d+\.$/.test(value)) correctedValue = value.slice(0, -1);

        pDetail[name] = correctedValue;
      }
    }

    // PHONE validation
    else if (name === "phno") {
      if ((Number(value) >= 0 || value === "") && value.length <= 10) {
        pDetail[name] = value;
      }
    }

    // EMAIL always raw (no formatting)
    else if (name === "email") {
      pDetail[name] = value;
    }

    // DOB validation
    else if (name === "dob") {
      if (value <= todayDate) {
        pDetail[name] = value;
        const calculatedAge = calculateAge(value, pDetail);

        // Age is populated programmatically from DOB, so its validation error
        // must also be cleared programmatically (the age onChange does not run).
        if (calculatedAge !== null) {
          setFormErrors((previousErrors) => ({
            ...previousErrors,
            dob: "",
            age: "",
          }));
        }
      }
    }

    // Reference field logic
    else if (name === "reference") {
      if (typeof value === "object" && value !== null) {
        pDetail.visit.referenceId = value.id;
        pDetail.visit.reference.refby = value.label;
        pDetail.visit.reference.refkey = "";
      } else {
        pDetail.visit.referenceId = null;
        pDetail.visit.reference.refby = value;
        pDetail.visit.reference.refkey = "";
      }
    } else if (name === "adhar") {
      if ((Number(value) >= 0 || value === "") && value.length <= 12) {
        pDetail[name] = value;
      }
    } else if (name === "altPhno") {
      if ((Number(value) >= 0 || value === "") && value.length <= 10) {
        pDetail[name] = value;
      }
    }

    // Name validations
    else if (
      [
        "fname",
        "mname",
        "lname",
        "fathern",
        "mothern",
        "fathernorspouse",
      ].includes(name)
    ) {
      const nameRegex = ["fname", "mname", "lname"].includes(name)
        ? /^[A-Za-z ]*$/
        : /^[A-Za-z0-9/ ]*$/;

      if (value === "" || nameRegex.test(value)) {
        // Format name fields always
        pDetail[name] = formatText(value);
      }
    }

    // General case — formatting based on skip rule
    else {
      pDetail[name] = noFormatFields.includes(name) ? value : formatText(value);
    }

    setPatientDetail(pDetail);
    console.log("Updated pDetail:", pDetail);
  };

  const getAgeFromDOB = (dob) => {
    if (!dob) return null;

    const birthDate = new Date(dob);
    if (isNaN(birthDate.getTime())) {
      console.warn("Invalid date provided:", dob);
      return null;
    }
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  };

  const calculateAge = (dob, pDetail) => {
    const age = getAgeFromDOB(dob);
    if (age !== null) {
      // patientDetail.age = age;
      pDetail.age = age.toString();
    }
    return age;
  };

  const onValueChange = (e) => {
    e = "selfie";
    //setSelectedOption(e.target.value);
    setSelectedOption(e);
    setShowWebCamModal(true);
    console.log("camera option selected event.target.value", e, "..", e);
    console.log("camera option selected", selectedOption);
  };

  const handleCheckbox = (e) => {
    //patientDetail.insurance = value;
    console.log("value:", e.target);
    let pDetail = patientDetail;
    pDetail.insurance = pDetail.insurance == "YES" ? "NO" : "YES";
    console.log("pDetail:", pDetail);
    setPatientDetail({ ...pDetail });
  };

  const capture = (event) => {
    event.preventDefault();
    let picture = webcamRef.Blob;
    // webcam.snap();
    console.log("webcamRef pic ", picture);
    const imageSrc = webcamRef.current.getScreenshot();
    console.log("imageSrc : ", imageSrc);
    let video = videoRef.current;
    let photo = photoRef.current;
    console.log(
      "let photo = photoRef.current :",
      photo,
      "    let video = videoRef.current :",
      video,
    );
    const blob = fetch(imageSrc).then((res) => res.blob());
    console.log("selfie blob : ", blob, blob.Blob);
    var data = imageSrc.toString().replace(/^data:image\/jpg;base64,/, "");
    var buf = Buffer.from(data, "base64");
    console.log("data and buf :", data, buf);
    var file = picture;
    var reader = new FileReader();
    var url = null;
    // reader.readAsDataURL(blob);
    // var objurl = URL.createObjectURL(file);
    setImgSrc(imageSrc);
    setUploadFile({
      patientId: patientDetail.id,
      name: patientDetail.fname,
      phno: patientDetail.phno,
      imgurl: "",
      type: "profilepic",
      file: imageSrc,
    });
    console.log(
      "image src data : ",
      imageSrc.file,
      imageSrc.data,
      "imgSrc :",
      imgSrc,
      imageSrc,
    );
    // patientDetail.upload.file = imageSrc;
    setShowWebCam(true);
  };

  const onImageSubmit = (event) => {
    event.preventDefault();

    const blob = fetch(imgSrc).then((res) => res.blob());
    console.log("selfie blob : ", blob, blob.Blob);
    const formData = new FormData();
    formData.append("image", blob);
    formData.append("imageurl", imgSrc);
    console.log("formData", formData);
    console.log("selfie image : ", formData);
    var setPatient = { patientDetail };
    console.log("uploadFile :", uploadFile);
    setPatient.upload = uploadFile;
    patientDetail.upload = uploadFile;
    console.log("patient detail : ", patientDetail);
  };
  const handleTokenPrint = () => {
    console.log("patientDetail", patientDetail);
    setPrintTOkenModal(true);
    setTimeout(() => {
      setPrintTOkenModal(false);
    }, 500);
  };

  const handleOnboard = () => {
    props.openOnboardModal(props.patientInfo);
  };
  const onFileCancel = (event) => {
    event.preventDefault();
    setImgSrc(null);
    setShowWebCam(false);
  };

  const toggleModal = () => {
    setShowWebCamModal(!showWebCamModal);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (patientDetail.type == "") {
      patientDetail.type = "OutPatient";
    }
    if (props.type == "adminAppoinment") {
      patientDetail.iStatus = "NotInSite";
      // if (patientDetail.adhar == "0" || patientDetail.adhar.length < 12) {
      //   patientDetail.adhar = "000000000000";
      // }
    }
    if (patientDetail.gender == "") {
      // patientDetail.gender = "Male";
    }
    console.log("patientdetail before foreach loop", patientDetail);
    console.log(
      "patientdetail before foreach loop",
      Object.keys(patientDetail),
    );
    Object.keys(patientDetail).forEach((key) => {
      console.log("key", patientDetail[key]);
      validateField(key, patientDetail[key]);
      console.log("patientInfo:", event);
    });
    validateForm(event);
    setMessageStrip({ success: event.successMessages });
    setTimeout(() => {
      console.log("props:", props);
    }, 3000);
  };

  const setMessageStrip = (e) => {
    console.log("message obtained", e);
    var ServerResVal = ServerRes;
    if (e.success) {
      console.log("success message:", e.success);
      ServerResVal.success = e.success;
    } else {
      console.log("error message:", e.error);
      ServerResVal.error = e.error;
    }
    setServerRes({ ...ServerResVal });
    setTimeout(() => {
      closeAlert();
    }, 5000);
  };

  const validateField = (fieldName, value) => {
    if (patientDetail.type === "Other" && org?.orgCode === ORG_CODES.MNH) {
      return;
    }
    let fieldValidationErrors = formErrors;
    let basicInfo = patientDetail;
    console.log("Basic Info", basicInfo);
    console.log("FieldName", fieldName, "Value", value);
    var pattern = new RegExp(/^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/);
    var phoneNoPattern = new RegExp(/^[0-9]{10}$/);
    // var currentDate = new Date().getDate;
    switch (fieldName) {
      case "fname":
        fieldValidationErrors.fname =
          value.length > 0 ? "" : "Please Enter First Name";
        basicInfo.fname = value !== "" ? value : "";
        break;

      case "adhar":
        // Skip validation if it's an appointment and field is empty
        // if (props.type === "adminAppoinment") {
        //   if (!value) {
        //     break;
        //   } else if (value.length !== 12) {
        //       fieldValidationErrors.adhar =
        //         value.length == 12 ? "" : "Please Enter Valid Aadhaar Number";
        //     basicInfo.adhar = value !== "" ? value : "";
        //     break;
        //   }
        //   break; // Valid 12-digit Aadhaar in appointment form
        // }

        // if (!org?.isAadharNumberMandatory.onboarding && !patientDetail.adhar) break;
        // else if (!org?.isAadharNumberMandatory.onboarding && value) {
        //   fieldValidationErrors.adhar =
        //       value.length == 12 ? "" : "Please Enter Valid Aadhaar Number";
        //   basicInfo.adhar = value !== "" ? value : "";
        //   break;
        // }

        // if ((fieldValidationErrors.adhar = value.length == 0)) {
        //   fieldValidationErrors.adhar =
        //     value.length == 0 ? "Please Enter Aadhaar Number" : "";
        //   basicInfo.adhar = value !== "" ? value : "";
        //   break;
        // } else {
        //   fieldValidationErrors.adhar =
        //     value.length == 12 ? "" : "Please Enter Valid Aadhaar Number";
        //   basicInfo.adhar = value !== "" ? value : "";
        //   break;
        // }
        const aadhaarRegex = /^\d{12}$/;
        const isAadhaarMandatory = isAadhaarMandatoryForOnboarding(
          org,
          patientDetail.type,
        );

        if (!value) {
          fieldValidationErrors.adhar =
            isAadhaarMandatory && props.type !== "adminAppoinment"
              ? "Aadhaar number is required"
              : "";
        } else if (!aadhaarRegex.test(value)) {
          fieldValidationErrors.adhar =
            "Please enter a valid 12-digit Aadhaar number";
        } else {
          fieldValidationErrors.adhar = "";
          basicInfo.adhar = value;
        }

        break;

      case "gender":
        fieldValidationErrors.gender =
          value.length > 0 ? "" : "Please Select Gender";
        basicInfo.gender = value !== "" ? value : "";
        break;
      // case "dob":
      //   fieldValidationErrors.dob = value.length > 0 ? '' : 'Please Select Date of Birth';
      //   basicInfo.dob = value <=currentDate ? value : '';
      //   break;
      // case "adhar":
      //   fieldValidationErrors.adhar = value !== '' ? '' : 'Please Enter Adhar Number';
      //   fieldValidationErrors.adhar = !pattern.test(value) ? 'Please enter valid Adhar Number': '';
      //   basicInfo.adhar = value !== '' ? value : '';

      case "phno":
        //fieldValidationErrors.phno = value !== '' ? '' : 'Please Enter Phone Number';
        //basicInfo.phno = value !== '' ? value : '';
        // fieldValidationErrors.phno = !phoneNoPattern.test(value) ? 'Please enter valid Phone Number': '';
        // basicInfo.phno = value !== '' ? value : '';
        if ((fieldValidationErrors.phno = value.length == 0)) {
          fieldValidationErrors.phno =
            value.length == 0 ? "Please Enter Phone Number" : "";
          basicInfo.phno = value !== "" ? value : "";
          break;
        } else {
          fieldValidationErrors.phno =
            value.length == 10 ? "" : "Please Enter Valid Phone Number";
          basicInfo.phno = value !== "" ? value : "";
          break;
        }
      case "city":
        fieldValidationErrors.city =
          value.length == 0 ? "Please Enter City" : "";
        basicInfo.city = value !== "" ? value : "";
        break;
      // };
      case "state":
        fieldValidationErrors.state =
          value.length == 0 ? "Please Enter State" : "";
        basicInfo.state = value !== "" ? value : "";
        break;
      // };

      case "age":
        fieldValidationErrors.age = value.length == 0 ? "Please Enter Age" : "";
        if (value.length > 0) {
          fieldValidationErrors.age = value < 0 ? "Please enter valid Age" : "";
        }
        basicInfo.age = value !== "" ? value : "";
        break;
      case "emrPhono":
        // if (fieldValidationErrors.emrPhono = value.length == 0) {
        //   fieldValidationErrors.emrPhono = value.length == 0 ? 'Please Enter Phone Number' : '';
        //   basicInfo.emrPhono = value !== '' ? value : '';
        //   break;
        // } else {
        if (value.length > 0) {
          fieldValidationErrors.emrPhono =
            value.length == 10 ? "" : "Please Enter Valid Phone Number";
          basicInfo.emrPhono = value !== "" ? value : "";
          break;
        }

      // };
      // case "email":
      //   if(!isEmail(value)){
      //     fieldValidationErrors.email = value == isEmail ? '' : 'Please Enter Email';
      //     basicInfo.email = value !== '' ? value : '';
      //     break;
      //   }else{
      //     fieldValidationErrors.email = value.length <= 0 ? '' : '';
      //     basicInfo.email = value !== '' ? value : '';
      //     break;
      //   };

      default:
        break;
    }
    console.log("fieldValidationErrors:", fieldValidationErrors);
    setFormErrors({ ...fieldValidationErrors });
  };

  const validateForm = (event) => {
    event.preventDefault();
    var ServerResVal = ServerRes;

    var pDetail = patientDetail;
    // var age = patientDetail.age == '' ? getAge(patientDetail.dob) : patientDetail.age;
    // console.log("Age", age)
    // pDetail['age'] = age;
    setPatientDetail(pDetail);

    console.log("PDetails", patientDetail);
    if (patientDetail.checkAdharUpdate == "NO") {
      patientDetail.adhar = null;
    }

    let admissionDateTime = "";
    if (
      patientDetail.type === "InPatient" ||
      patientDetail.type === "Walkin"
    ) {
      const dateTimeString = `${selecteddate} ${selectedTime}:00`;
      admissionDateTime = dateTimeString;
      console.log("timestamp", admissionDateTime);
    }
    let formValid = true;
    if (patientDetail.type === "Other" && org?.orgCode === ORG_CODES.MNH) {
      formValid = true;
      patientDetail.visit.visitflag = "Other";
    } else {
      formValid =
        formErrors.fname === "" &&
        formErrors.age === "" &&
        formErrors.email === "" &&
        formErrors.adhar === "" &&
        formErrors.phno === "" &&
        formErrors.dob === "" &&
        formErrors.city === "" &&
        formErrors.state === "" &&
        formErrors.emrPhono === "" &&
        formErrors.gender === "";
    }
    console.log("formValid:", formValid);

    if (formValid) {
      setIsDisabled(!isDisabled);
      if (patientDetail.type === "Other") {
        patientDetail.type = "OutPatient";
        patientDetail.visitflag = "Other";
        patientDetail.visit = patientDetail.visit || {};
        patientDetail.visit.visitflag = "Other";
      } else if (patientDetail.type === "Walkin") {
        patientDetail.type = "InPatient";
        patientDetail.visitflag = "Walkin";
        patientDetail.visit = patientDetail.visit || {};
        patientDetail.visit.visitflag = "Walkin";
      } else if (patientDetail.type === "Proxy") {
        patientDetail.type = "OutPatient";
        patientDetail.visitflag = "Proxy";
        patientDetail.visit = patientDetail.visit || {};
        patientDetail.visit.visitflag = "Proxy";
      } else {
        patientDetail.visitflag = null;
        if (patientDetail.visit) {
          patientDetail.visit.visitflag = null;
        }
      }

      if (callType === "Add") {
        let flag;
        if (props && props.appointment) {
          flag = "appointment";
        } else {
          flag = "preReg";
        }
        dispatch(
          patientActions.addPatient(
            patientDetail,
            flag,
            admissionDateTime,
            (resCb) => {
              if (resCb) {
                console.log("Rescb", resCb);
                if (resCb.successMessages) {
                  props.onSuccess(resCb, "payment");
                  // ServerResVal.success = resCb.successMessages;
                  // resCb.data.id
                  props.closePatientForm();
                }
                setServerRes({ ...ServerResVal });
                if (resCb.errorMessages) {
                  props.onSuccess(resCb, "payment");
                  // ServerResVal.error = resCb.errorMessages
                  props.closePatientForm();
                }
              }
            },
          ),
        );
      } else {
        // patientDetail ['']
        // patientDetail.upload = uploadFile;
        console.log("update patient input :", patientDetail);
        if (patientDetail != "") {
          const list = customerGroup || [];
          console.log("Rescb", patientDetail);
          const matchedGroup = list.find(
            (group) => group.custGroupId == patientDetail.custGroupId,
          );
          patientDetail.custGrpDesc = matchedGroup?.description || "";
          console.log("Rescb", patientDetail);
        }
        let convert = "";
        if (props.isDependent) {
          console.log("update patient input :", patientDetail);
          console.log("inside submit props.isDependent:", props.isDependent);
          let motherPatientID = patientDetail.patientId;
          let motherVisitId = patientDetail.visitId;
          patientDetail.id = "";
          patientDetail.patientId = "";
          patientDetail.visitId = "";
          patientDetail.erpCustId = "";
          patientDetail.ehrid = "";
          dispatch(
            patientActions.addDependent(
              patientDetail,
              motherPatientID,
              motherVisitId,
              (resCb) => {
                if (resCb) {
                  console.log("Rescb", resCb);
                  if (resCb.successMessages) {
                    ServerResVal.success =
                      "Patient details updated successfully.";
                  } else if (resCb.state === "error") {
                    ServerResVal.error = "Failed to update patient details.";
                  }
                  setServerRes({ ...ServerResVal });
                  // closeProfileEdit();
                  props.onSuccess(resCb, "");
                  props.closePatientForm();
                }
              },
            ),
          );
        } else {
          dispatch(
            patientActions.updatePatient(
              patientDetail,
              convert,
              admissionDateTime,
              (resCb) => {
                if (resCb) {
                  console.log("Rescb", resCb);
                  if (resCb.successMessages) {
                    ServerResVal.success =
                      "Patient details updated successfully.";
                  } else if (resCb.state === "error") {
                    ServerResVal.error = "Failed to update patient details.";
                  }
                  setServerRes({ ...ServerResVal });
                  // closeProfileEdit();
                  props.onSuccess(resCb, "");
                  props.closePatientForm();
                }
              },
            ),
          );
        }
      }
    } else {
      setTimeout(() => {
        var errors = document.querySelectorAll(".is-invalid");
        console.log("errors:", errors);
        if (errors.length > 0) {
          errors[0].focus();
        }
      }, 500);
    }
  };

  const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const toggleBasicInfo = () => {
    setviewBasicInfo(!viewBasicInfo);
  };

 const onSelectedGender = (value) => {
  setSelectedGender(value);
  console.log("setSelectedGender", value);
  setPatientDetail(prev => ({
    ...prev,
    gender: value
  }));
  // Clear the gender error when a gender is selected
  setFormErrors(prev => ({
    ...prev,
    gender: ""
  }));
};

  const handleRadioKeyDown = (e, index) => {
    const lastIndex = radioRefs.current.length - 1;

    if (e.key === "Tab") {
      // Shift + Tab  → go to previous radio (if not the first)
      if (e.shiftKey && index > 0) {
        e.preventDefault();
        radioRefs.current[index - 1]?.focus();
        return;
      }

      // Tab → go to next radio (if not the last)
      if (!e.shiftKey && index < lastIndex) {
        e.preventDefault();
        radioRefs.current[index + 1]?.focus();
        return;
      }

      // First + Shift+Tab OR Last + Tab → allow normal browser behavior
    }
  };
  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };
  const closePdfModal = (event) => {
    setPrintTOkenModal(false);
  };
  const backToUserList = () => {
    console.log("props:", props);
    props.props.history.push({
      pathname: `/patient`,
    });
    if (document.getElementById("user-list"))
      document.getElementById("user-list").classList.remove("mobile-view");
    if (document.getElementById("user-info"))
      document.getElementById("user-info").classList.remove("mobile-view");
  };

  const toggle = (event) => {
    setModalopen(!modalopen);
  };

  const closeProfileEdit = () => {
    props.closePatientForm();
  };

  const modalPopUp = () => {
    setModalopen(true);
    // var ServerResVal = ServerRes;
    // ServerResVal.success = "Patient details updated successfully."
    // setServerRes({ ...ServerResVal });
  };

  const addZeroSuffix = (number) => {
    const numberString = number.toString();
    if (numberString.length !== 8) {
      const suffix = "0".repeat(8 - numberString.length);
      return suffix + numberString;
    }
    return numberString;
  };

  const convertToInPatient = () => {
    //setModalopen(false);
    var ServerResVal = ServerRes;
    console.log("convert to inpatient button clicked");
    patientDetail.type = "InPatient";
    let convert = "convertToInPatient";
    dispatch(
      patientActions.updatePatient(patientDetail, convert, (resCb) => {
        if (resCb) {
          console.log("Rescb", resCb.state, resCb.message);
          if (resCb.successMessages) {
            console.log("success message");
            ServerResVal.success = "Patient details updated successfully.";
          } else if (resCb.state === "error") {
            ServerResVal.error = "Failed to update patient details.";
          }
          setServerRes({ ...ServerResVal });
          // setTimeout(() => {
          //   closeAlert();
          // }, 3000);
          setModalopen(false);
        }
      }),
    );
  };
  return (
    <main className="" key={reload}>
      {ServerRes.success && (
        // <Alert theme="success" className="alert-div">{ServerRes.success}<span><i className="material-icons" onClick={(event) => closeAlert(event)} style={{ cursor: 'pointer' }}>close</i></span></Alert>
        <Alert severity="success" className="alert-div">
          {ServerRes.success}{" "}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(event) => closeAlert(event)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}
      {ServerRes.error && (
        // <Alert theme="danger" className="alert-div">{ServerRes.error}<span><i className="material-icons" onClick={(event) => closeAlert(event)} style={{ cursor: 'pointer' }}>close</i></span></Alert>
        <Alert severity="error" className="alert-div">
          {ServerRes.error}{" "}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(event) => closeAlert(event)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}

      {props?.type !== "adminAppoinment" && (
        <Dialog
          class="basicInformation"
          open={editProfile}
          onClose={closeProfileEdit}
          aria-labelledby="edit-profile-dialog"
          fullWidth
          maxWidth="lg" // Size="lg" equivalent for width
          disableEnforceFocus
        >
          <div>
            <DialogTitle
              style={{
                position: "sticky",
                top: "0px",
                backgroundColor: "#fff",
                height: "80px",
                zIndex: "100",
              }}
            >
              <div class="dialogCloseIcon">
                Basic Information
                <div className="d-flex align-items-center" id="custGrp">
                  <FormControl class="input px-3">
                    <Select
                      name="customerGroup"
                      value={patientDetail?.custGroupId ?? ""}
                      onChange={(event) => {
                        const selected = customerGroup?.find(
                          (group) => group?.custGroupId === event.target.value,
                        );

                        setPatientDetail((prev) => ({
                          ...prev,
                          custGroupId: selected?.custGroupId ?? null,
                          custGrpDesc: selected?.description ?? "",
                        }));
                      }}
                      disabled={!customerGroup || customerGroup.length === 0}
                    >
                      {customerGroup?.length > 0 ? (
                        customerGroup.map((group) => (
                          <MenuItem
                            key={group?.custGroupId}
                            value={group?.custGroupId}
                          >
                            {group?.description ?? "N/A"}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled value="">
                          No customer groups available
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                  <FormControl class="input">
                    <Select
                      name="category"
                      className="form-control filterin Quantity"
                      value={patientDetail.type}
                      disabled={callType === "Edit"}
                      onChange={(event) =>
                        handleInputChange("type", event.target.value)
                      }
                    >
                      <MenuItem value="InPatient">In Patient</MenuItem>
                      <MenuItem value="OutPatient">Out Patient</MenuItem>
                      
                      {org?.isOnlinePatient?.display && org?.orgCode !== ORG_CODES.VEDAMAAYU && (
                        <MenuItem value="OnlinePatient">Online Patient</MenuItem>
                      )}
                      {org?.orgCode === ORG_CODES.MNH && (
                        <MenuItem value="Other">Other</MenuItem>
                      )}
                       {(org?.orgCode === ORG_CODES.VEDAMAAYU || patientDetail.type === "Walkin") && (
                        <MenuItem value="Walkin">Walk In</MenuItem>
                      )}
                       {/* Hide Proxy during patient creation
{org?.orgCode === ORG_CODES.VEDAMAAYU && (
  <MenuItem value="Proxy">Proxy</MenuItem>
)}
*/}
                      
                      
                    </Select>
                  </FormControl>
                  {org?.orgCode === ORG_CODES.MNH && (
                    <FormControl class="input" style={{ marginLeft: "10px" }}>
                      <Select
                        name="department"
                        value={patientDetail.department || ""}
                        onChange={(event) =>
                          handleInputChange("department", event.target.value)
                        }
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select Department
                        </MenuItem>
                        {department.map((dept) => (
                          <MenuItem key={dept.id} value={dept.id}>
                            {dept.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                  <FormControl class="input" style={{ marginLeft: "10px" }}>
                    <Autocomplete
                      freeSolo
                      options={docList.map((d) => ({
                        id: d.id,
                        label: d.label,
                      }))}
                      getOptionLabel={(option) => {
                        // When option is a string (typing)
                        if (typeof option === "string") return option;

                        // When option is an object (doctor)
                        return option.label || "";
                      }}
                      value={patientDetail.visit.reference.refby || ""}
                      onChange={(e, value) => {
                        // 'value' can be string (custom) or object (selected doctor)
                        if (typeof value === "string") {
                          {
                            console.log("value", value);
                          }
                          handleInputChange("reference", value);
                        } else if (value && value.id) {
                          handleInputChange("reference", value);
                          {
                            console.log("value", value);
                          }
                        } else {
                          handleInputChange("reference", "");
                        }
                      }}
                      onInputChange={(e, value) => {
                        // always capture typed text too
                        handleInputChange("reference", value);
                      }}
                      sx={{
                        "& .MuiAutocomplete-endAdornment": {
                          top: "50%",
                          transform: "translateY(-50%)",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Reference"
                          variant="outlined"
                          size="small"
                          style={{ width: 250 }}
                          InputLabelProps={{
                            style: {
                              color: "rgba(0, 0, 0, 0.87)", // same as MenuItem text color
                              fontWeight: 400, // same as MenuItem
                            },
                          }}
                        />
                      )}
                    />
                  </FormControl>
                  <IconButton
                    className="cpointer"
                    aria-label="close"
                    onClick={closeProfileEdit}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
            </DialogTitle>

            <DialogContent
              className="informationContent"
              style={{ overflowY: "auto" }}
            >
              <div>
                <Grid container className="patient-edit-form">
                  <Box style={{ fontSize: "14px", width: "100%" }}>
                    <Grid container spacing={2} className="padding1">
                      {patientDetail.type === "InPatient" ||
                      patientDetail.type === "Walkin" ? (
                        <Grid item md={4}>
                          <label htmlFor="birthdetails">Admission Date</label>
                          <TextField
                            name="admissionDate"
                            id="admissionDate"
                            className="form-control filterin Quantity"
                            placeholder="Enter Scheduled Date"
                            autoComplete="off"
                            type="date"
                            defaultValue={selecteddate}
                            onChange={(event) => handleOnChange("date", event)}
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              style: { height: "35px" },
                            }}
                          />
                        </Grid>
                      ) : (
                        ""
                      )}

                      {patientDetail.type === "InPatient" ||
                      patientDetail.type === "Walkin" ? (
                        //     <Col md="4" className="form-group">
                        //     <label htmlFor="birthdetails">Admission Time</label>
                        //     <input
                        //   name="admissionTime"
                        //   id="admissionTime"
                        //   className="form-control filterin Quantity"
                        //   placeholder="Enter Scheduled Time"
                        //   required
                        //   type="time"
                        //   defaultValue={selectedTime}
                        //   onChange={(event)=>handleOnChange("time",event)}
                        // />
                        //     </Col>

                        <Grid item md={4}>
                          <label htmlFor="birthdetails">Admission Time</label>
                          <TextField
                            name="admissionTime"
                            id="admissionTime"
                            className="form-control filterin Quantity"
                            placeholder="Enter Scheduled Time"
                            autoComplete="off"
                            type="time"
                            defaultValue={selectedTime}
                            onChange={(event) => handleOnChange("time", event)}
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              style: { height: "35px" },
                            }}
                          />
                        </Grid>
                      ) : (
                        ""
                      )}
                      {patientDetail.type === "InPatient" ||
                      patientDetail.type === "Walkin" ? (
                        <Grid item md={4}></Grid>
                      ) : (
                        ""
                      )}
                      <Grid item md={4}>
                        {/* <label htmlFor="fname">First Name <span className='text-danger'>*</span></label> */}

                        <TextField
                          className="p-2"
                          label="First Name"
                          id="fname"
                          value={patientDetail.fname}
                          // placeholder="First Name"
                          required
                          sx={{
                            "& .MuiFormLabel-asterisk": {
                              color: "var(--bs-danger)",
                            },
                          }}
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("fname", event.target.value)
                          }
                          error={formErrors.fname !== ""}
                          helperText={
                            <span style={{ color: "#EC4147" }}>
                              {formErrors.fname}
                            </span>
                          }
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>
                      <Grid item md={4}>
                        {/* <label htmlFor="mname">Middle Name</label> */}
                        <TextField
                          className="p-2"
                          label="Middle Name"
                          id="mname"
                          value={patientDetail.mname}
                          placeholder="Middle Name"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("mname", event.target.value)
                          }
                          // variant="outlined"
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>
                      <Grid item md={4}>
                        {/* <label htmlFor="lname">Last Name</label> */}
                        <TextField
                          className="p-2"
                          label="Last Name"
                          id="lname"
                          value={patientDetail.lname}
                          placeholder="Last Name"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("lname", event.target.value)
                          }
                          // variant="outlined"
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>
                    </Grid>

                    {props.isDependent ? (
                      // For dependents - show only mother and father names
                      <Grid container spacing={2} className="padding1">
                        {/* Mother Name */}
                        <Grid item md={4}>
                          <TextField
                            className="p-2"
                            label="Mother Name"
                            id="mothern"
                            value={patientDetail.mothern}
                            placeholder="Mother Name"
                            autoComplete="off"
                            onChange={(event) =>
                              handleInputChange("mothern", event.target.value)
                            }
                            error={formErrors.fname !== ""}
                            helperText={
                              <span style={{ color: "#EC4147" }}>
                                {formErrors.fname}
                              </span>
                            }
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              style: { height: "35px" },
                            }}
                          />
                        </Grid>

                        {/* Father Name */}
                        <Grid item md={4}>
                          <TextField
                            className="p-2"
                            label="Father Name"
                            id="fathern"
                            value={patientDetail.fathern}
                            placeholder="Father Name"
                            autoComplete="off"
                            onChange={(event) =>
                              handleInputChange("fathern", event.target.value)
                            }
                            // error={formErrors.fname !== ""}
                            // helperText={
                            //   <span style={{ color: "#EC4147" }}>{formErrors.fname}</span>
                            // }
                            // variant="outlined"
                            fullWidth
                            InputProps={{
                              style: { height: "35px" },
                            }}
                          />
                        </Grid>
                      </Grid>
                    ) : (
                      // For normal patients - show all three fields
                      <Grid container spacing={2} className="padding1">
                        {/* Spouse Name */}
                        <Grid item md={4}>
                          <TextField
                            className="p-2"
                            label="Spouse Name"
                            id="fathernorspouse"
                            value={patientDetail.fathernorspouse}
                            placeholder="Spouse Name"
                            autoComplete="off"
                            onChange={(event) =>
                              handleInputChange(
                                "fathernorspouse",
                                event.target.value,
                              )
                            }
                            // error={formErrors.fname !== ""}
                            // helperText={
                            //   <span style={{ color: "#EC4147" }}>{formErrors.fname}</span>
                            // }
                            // variant="outlined"
                            fullWidth
                            InputProps={{
                              style: { height: "35px" },
                            }}
                          />
                        </Grid>

                        {/* Father Name */}
                        <Grid item md={4}>
                          <TextField
                            className="p-2"
                            label="Father Name"
                            id="fathern"
                            value={patientDetail.fathern}
                            placeholder="Father Name"
                            autoComplete="off"
                            onChange={(event) =>
                              handleInputChange("fathern", event.target.value)
                            }
                            // error={formErrors.fname !== ""}
                            // helperText={
                            //   <span style={{ color: "#EC4147" }}>{formErrors.fname}</span>
                            // }
                            // variant="outlined"
                            fullWidth
                            InputProps={{
                              style: { height: "35px" },
                            }}
                          />
                        </Grid>

                        {/* Mother Name */}
                        <Grid item md={4}>
                          <TextField
                            className="p-2"
                            label="Mother Name"
                            id="mothern"
                            value={patientDetail.mothern}
                            placeholder="Mother Name"
                            autoComplete="off"
                            onChange={(event) =>
                              handleInputChange("mothern", event.target.value)
                            }
                            // error={formErrors.fname !== ""}
                            // helperText={
                            //   <span style={{ color: "#EC4147" }}>{formErrors.fname}</span>
                            // }
                            // variant="outlined"
                            fullWidth
                            InputProps={{
                              style: { height: "35px" },
                            }}
                          />
                        </Grid>
                      </Grid>
                    )}

                    <Grid
                      container
                      spacing={2}
                      className="d-flex justify-content-between padding1"
                    >
                      <Grid item md={4}>
                        {/* <label htmlFor="phno">Phone Number <span className='text-danger'>*</span></label> */}
                        <TextField
                          className="p-2"
                          label="Phone Number"
                          required
                          id="phno"
                          type="number"
                          value={patientDetail.phno}
                          // placeholder="Phone Number"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("phno", event.target.value)
                          }
                          sx={{
                            "& .MuiFormLabel-asterisk": {
                              color: "var(--bs-danger)",
                            },
                          }}
                          onKeyDown={handleKeyDown}
                          error={formErrors.phno !== ""}
                          helperText={
                            <span style={{ color: "#EC4147" }}>
                              {formErrors.phno}
                            </span>
                          }
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>

                      <Grid item md={4}>
                        {/* <label htmlFor="age">Age <span className='text-danger'>*</span></label> */}
                        <TextField
                          className="p-2"
                          label="Age"
                          required
                          type="number"
                          id="age"
                          min={0}
                          value={patientDetail.age}
                          // placeholder="Age"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("age", event.target.value)
                          }
                          sx={{
                            "& .MuiFormLabel-asterisk": {
                              color: "var(--bs-danger)",
                            },
                          }}
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          error={formErrors.age !== ""}
                          helperText={
                            <span style={{ color: "#EC4147" }}>
                              {formErrors.age}
                            </span>
                          }
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            min: 0,
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>

                      <Grid item md={4}>
                        <label htmlFor="gender">
                          Gender <span className="text-danger">*</span>
                        </label>
                        <RadioGroup
                          className="radioGroup"
                          row
                          aria-label="gender"
                          name="gender"
                          value={selectedGender}
                          onChange={(event) =>
                            onSelectedGender(event.target.value)
                          }
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        >
                          <FormControlLabel
                            value="Male"
                            className="radioMale"
                            control={
                              <Radio
                                inputRef={(el) => (radioRefs.current[0] = el)}
                                onKeyDown={(e) => {
                                  handleRadioKeyDown(e, 0);

                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    e.target.click(); // <-- ensures UI selection happens
                                  }
                                }}
                              />
                            }
                            label="Male"
                          />

                          <FormControlLabel
                            value="Female"
                            className="radioMale"
                            control={
                              <Radio
                                inputRef={(el) => (radioRefs.current[1] = el)}
                                onKeyDown={(e) => {
                                  handleRadioKeyDown(e, 1);

                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    e.target.click();
                                  }
                                }}
                              />
                            }
                            label="Female"
                          />

                          <FormControlLabel
                            value="Others"
                            className="radioMale"
                            control={
                              <Radio
                                inputRef={(el) => (radioRefs.current[2] = el)}
                                onKeyDown={(e) => {
                                  handleRadioKeyDown(e, 2);

                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    e.target.click();
                                  }
                                }}
                              />
                            }
                            label="Others"
                          />
                        </RadioGroup>
                        <div style={{ color: "#EC4147" }}>
                          <span>{formErrors.gender}</span>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container spacing={2} className="padding1">
                      <Grid item md={4} className="alternateNo">
                        {/* <label htmlFor="altNumber">Alternate Phone Number</label> */}
                        <TextField
                          className="p-2"
                          label="Alternate Phone Number"
                          id="altNumber"
                          value={patientDetail.altPhno}
                          placeholder="Alternate phone number"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("altPhno", event.target.value)
                          }
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>

                      <Grid item md={4}>
                        <label htmlFor="birthdetails" className="birthLabel">
                          {" "}
                          Date Of Birth
                        </label>
                        <TextField
                          className="birthDtls"
                          type="date"
                          id="birthdetails"
                          max={todayDate}
                          value={patientDetail.dob}
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("dob", event.target.value)
                          }
                          error={formErrors.dob !== ""}
                          helperText={
                            <span style={{ color: "#EC4147" }}>
                              {formErrors.dob}
                            </span>
                          }
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                          inputProps={{
                            max: todayDate,
                          }}
                        />
                      </Grid>

                      <Grid item md={4} className="form-group">
                        <label htmlFor="bgproup" className="bloodGroupLabel">
                          Blood Group
                        </label>
                        <FormControl fullWidth class="bloodGroup">
                          <Select
                            displayEmpty
                            labelId="bloodgroup-label"
                            id="bloodgroup"
                            value={patientDetail.bloodgroup}
                            onChange={(event) => {
                              handleInputChange(
                                "bloodgroup",
                                event.target.value,
                              );
                            }}
                          >
                            <MenuItem value="">--Choose an option--</MenuItem>
                            <MenuItem value="A +ve">A +ve</MenuItem>
                            <MenuItem value="A -ve">A -ve</MenuItem>
                            <MenuItem value="B +ve">B +ve</MenuItem>
                            <MenuItem value="B -ve">B -ve</MenuItem>
                            <MenuItem value="AB +ve">AB +ve</MenuItem>
                            <MenuItem value="AB -ve">AB -ve</MenuItem>
                            <MenuItem value="O +ve">O +ve</MenuItem>
                            <MenuItem value="O-ve">O -ve</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid container spacing={2} className="padding1">
                      <Grid item md={4}>
                        {/* <label htmlFor="language">Language</label> */}
                        <TextField
                          className="p-2"
                          label="Language"
                          id="language"
                          value={patientDetail.language}
                          placeholder="Language"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("language", event.target.value)
                          }
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>

                      <Grid item md={4}>
                        {/* <label htmlFor="education">Education</label> */}
                        <TextField
                          className="p-2"
                          label="Education"
                          id="education"
                          value={patientDetail.education}
                          placeholder="Education"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("education", event.target.value)
                          }
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>
                      <Grid item md={4}>
                        {/* <label htmlFor="sociostatus">Socio Status</label> */}
                        <TextField
                          className="p-2"
                          label="Socio Status"
                          id="sociostatus"
                          value={patientDetail.sociostatus}
                          placeholder="Socio Status"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("sociostatus", event.target.value)
                          }
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <FormGroup className="address">
                      {/* <label htmlFor="feInputAddress">Address</label> */}
                      <TextField
                        className="p-2"
                        label="Address"
                        id="feInputAddress"
                        value={patientDetail.address}
                        placeholder="1234 Main St"
                        autoComplete="off"
                        onChange={(event) => {
                          handleInputChange("address", event.target.value);
                        }}
                        fullWidth
                        InputProps={{
                          style: { height: "35px" },
                        }}
                      />
                    </FormGroup>

                    <Grid container spacing={2} className="padding1">
               <Grid item md={4}>
  <TextField
    className="p-2"
    label={
      isAadhaarMandatoryForOnboarding(org, patientDetail.type) &&
      props.type !== "adminAppoinment" ? (
        <span>
          Aadhaar <span style={{ color: "var(--bs-danger)" }}>*</span>
        </span>
      ) : (
        "Aadhaar"
      )
    }
    id="Adhar"
    // type="number"
    inputProps={{
      min: "0",
      max: "999999999999",
    }}
    value={patientDetail.adhar}
    placeholder="000011112222"
    autoComplete="off"
    onChange={(event) => {
      handleInputChange("adhar", event.target.value);
    }}
    onKeyDown={handleKeyDown}
    error={formErrors.adhar !== ""}
    helperText={formErrors.adhar}
    fullWidth
    InputProps={{
      style: { height: "35px" },
    }}
  />
</Grid>

                      <Grid item md={4}>
                        {/* <label htmlFor="EmergencyPhno">Emergency Phone Number</label> */}
                        <TextField
                          className="p-2"
                          label="Emergency Phone Number"
                          id="EmergencyPhno"
                          type="number"
                          value={patientDetail.emrPhono}
                          placeholder="Emergency Phone Number"
                          autoComplete="off"
                          onChange={(event) => {
                            const val = event.target.value.slice(0, 10);
                            handleInputChange("emrPhono", val);
                          }}
                          onKeyDown={handleKeyDown}
                          error={formErrors.emrPhono !== ""}
                          helperText={formErrors.emrPhono}
                          fullWidth
                          inputProps={{ maxLength: 10 }}
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>

                      <Grid item md={4}>
                        {/* <label htmlFor="srcRef">Source of Reference</label> */}
                        <TextField
                          className="p-2"
                          label="Source of Reference"
                          id="srcRef"
                          value={patientDetail.srcRef}
                          placeholder="Source of Reference"
                          autoComplete="off"
                          onChange={(event) => {
                            handleInputChange("srcRef", event.target.value);
                          }}
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} className="padding1">
                      <Grid item md={6}>
                        {/* <label htmlFor="email">Email Id</label> */}
                        <TextField
                          className="p-2"
                          label="Email Id"
                          id="email"
                          value={patientDetail.email}
                          placeholder="Email Id"
                          autoComplete="off"
                          onChange={(event) => {
                            handleInputChange("email", event.target.value);
                          }}
                          error={formErrors.email !== ""}
                          helperText={formErrors.email}
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>

                      <Grid item md={6}>
                        {/* <label htmlFor="oc">Occupation</label> */}
                        <TextField
                          className="p-2"
                          label="Occupation"
                          id="oc"
                          value={patientDetail.occupation}
                          placeholder="Occupation"
                          autoComplete="off"
                          onChange={(event) => {
                            handleInputChange("occupation", event.target.value);
                          }}
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} className="padding1">
                      <Grid item md={6}>
                        {/* <label htmlFor="feInputCity">
          City<span className='text-danger'>*</span>
        </label> */}
                        <TextField
                          className="p-2"
                          label="City"
                          id="feInputCity"
                          placeholder="City"
                          autoComplete="off"
                          value={patientDetail.city}
                          onChange={(event) => {
                            handleInputChange("city", event.target.value);
                          }}
                          error={formErrors.city !== ""}
                          helperText={formErrors.city}
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>

                      <Grid item md={4}>
                        {/* <label htmlFor="feInputState">
          State<span className='text-danger'>*</span>
        </label> */}
                        <TextField
                          className="p-2"
                          label="State"
                          id="feInputState"
                          placeholder="State"
                          autoComplete="off"
                          value={patientDetail.state}
                          onChange={(event) => {
                            handleInputChange("state", event.target.value);
                          }}
                          error={formErrors.state !== ""}
                          helperText={formErrors.state}
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>

                      <Grid item md={2}>
                        {/* <label htmlFor="feInputZip">Zip</label> */}
                        <TextField
                          className="p-2"
                          label="Zip"
                          id="feInputZip"
                          placeholder="Zip"
                          type="number"
                          autoComplete="off"
                          value={patientDetail.pincode}
                          onChange={(event) => {
                            handleInputChange("pincode", event.target.value);
                          }}
                          onKeyDown={handleKeyDown}
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid container className="my-2">
                      <Grid item>
                        <FormControlLabel
                          className="formControl"
                          control={
                            <Checkbox
                              checked={
                                patientDetail.insurance === "YES" ? true : false
                              }
                              onChange={(event) => {
                                handleCheckbox(event);
                              }}
                              color="primary" // You can change the color if desired
                            />
                          }
                          label="Do you have insurance?"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleCheckbox(e);
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                    {org?.orgCode === ORG_CODES.MANASWINI && (
                      <Grid container class="webcamMode">
                        <Grid item md={12}>
                          <p className="mb-2">
                            Please select your webcam mode:
                          </p>
                          <RadioGroup
                            class="webcam"
                            aria-label="webcam-mode"
                            name="webcamMode"
                            value={selectedOption}
                            onChange={onValueChange}
                            row
                          >
                            <Grid item md={4}>
                              <FormControlLabel
                                className="formControl"
                                value="selfie"
                                control={<Radio color="primary" />}
                                label="User/Selfie/forward facing camera"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    onValueChange({
                                      target: { value: "selfie" },
                                    });
                                  }
                                }}
                              />
                            </Grid>
                            <Grid item md={4}>
                              <FormControlLabel
                                className="formControl"
                                value="env"
                                control={<Radio color="primary" />}
                                label="Environment/Facing-Out camera"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    onValueChange({ target: { value: "env" } });
                                  }
                                }}
                              />
                            </Grid>
                          </RadioGroup>
                        </Grid>
                      </Grid>
                    )}
                    {/* 
                      <div className="fbtn mt-3">
                        <Button
                          type="submit"
                          onClick={(event) => handleSubmit(event)}
                        >
                          Next
                        </Button>
                      </div> */}
                    <br />
                    {/* 
                      {ServerRes.success &&
                        <Alert theme="success" className="alert-div">{ServerRes.success}<span><i className="material-icons" onClick={(event) => closeAlert(event)} style={{ cursor: 'pointer' }}>close</i></span></Alert>
                      }
                      {ServerRes.error &&
                        <Alert theme="danger" className="alert-div">{ServerRes.error}<span><i className="material-icons" onClick={(event) => closeAlert(event)} style={{ cursor: 'pointer' }}>close</i></span></Alert>
                      } */}
                  </Box>
                </Grid>
              </div>

              <Dialog
                className="showWebCamModal"
                open={showWebCamModal}
                onClose={toggleModal}
              >
                <DialogTitle>
                  <div class="dialogCloseIcon">
                    Capture Patient Image
                    <IconButton
                      className="cpointer"
                      aria-label="close"
                      onClick={toggleModal}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <Card className="card1">
                    {showWebCam === false ? (
                      <CardBody>
                        {selectedOption === "selfie" ? (
                          <Webcam
                            audio={false}
                            imageSmoothing={true}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            height={`250px`}
                            width={`350px`}
                            videoConstraints={videoConstraintsSelfie}
                          />
                        ) : (
                          <Webcam
                            audio={false}
                            imageSmoothing={true}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            height={`100px`}
                            width={`100px`}
                            videoConstraints={videoConstraints}
                          />
                        )}
                        <div>
                          <Button
                            className="buttOnMui"
                            variant="contained"
                            color="primary"
                            onClick={capture}
                            style={{ textTransform: "none" }}
                          >
                            Capture
                          </Button>
                        </div>
                      </CardBody>
                    ) : (
                      <>
                        {imgSrc && (
                          <>
                            <CardImg src={imgSrc} />
                            <CardBody>
                              <Button
                                className="buttOnMui"
                                variant="contained"
                                color="primary"
                                onClick={onImageSubmit}
                                style={{ textTransform: "none" }}
                              >
                                Save Image
                              </Button>
                              <Button
                                className="buttOnMui"
                                variant="contained"
                                color="primary"
                                onClick={onFileCancel}
                                style={{
                                  textTransform: "none",
                                  float: `right`,
                                }}
                              >
                                Cancel
                              </Button>
                            </CardBody>
                          </>
                        )}
                      </>
                    )}
                  </Card>
                </DialogContent>
                <DialogActions>
                  <Button
                    className="buttOnMui"
                    variant="contained"
                    color="primary"
                    onClick={toggleModal}
                    style={{ textTransform: "none" }}
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            </DialogContent>

            <DialogActions
              className="buttonNext"
              style={{ position: "sticky", bottom: 0, backgroundColor: "#fff" }}
            >
              <Button
                className="buttOnMui"
                variant="contained"
                color="primary"
                onClick={(event) => handleSubmit(event)}
                style={{ textTransform: "none" }}
                disabled={isDisabled}
              >
                {callType && callType === "Add" ? "Next" : "Submit"}
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      )}
      {props?.type === "adminAppoinment" && (
        <Dialog
          class="ad-app-form"
          open={editProfile}
          onClose={closeProfileEdit}
          aria-labelledby="edit-profile-dialog"
          fullWidth
          maxWidth="lg" // Size="lg" equivalent for width
          disableEnforceFocus
        >
          <div>
            <DialogTitle
              style={{
                position: "sticky",
                top: "0px",
                backgroundColor: "#fff",
                height: "80px",
                zIndex: "100",
              }}
            >
              <div class="dialogCloseIcon">
                Basic Information
                <div className="d-flex align-items-center" id="custGrp">
                  <FormControl class="input px-3">
                    <Select
                      name="customerGroup"
                      value={patientDetail.custGroupId}
                      onChange={(event) => {
                        const selected = customerGroup.find(
                          (group) => group.custGroupId === event.target.value,
                        );

                        setPatientDetail((prev) => ({
                          ...prev,
                          custGroupId: selected?.custGroupId,
                          custGrpDesc: selected?.description,
                        }));
                      }}
                    >
                      {customerGroup.map((group) => (
                        <MenuItem
                          key={group.custGroupId}
                          value={group.custGroupId}
                        >
                          {group.description}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl class="input">
                    <Select
                      name="category"
                      className="form-control filterin Quantity"
                      value={patientDetail.type}
                      disabled={true}
                      // onChange={(event) =>
                      //   handleInputChange("type", event.target.value)
                      // }
                    >
                      <MenuItem value="InPatient">In Patientss</MenuItem>
                      <MenuItem value="OutPatient">Out Patientss</MenuItem>
                      <MenuItem value="OnlinePatient">Online Patient</MenuItem>
                      {(org?.orgCode === ORG_CODES.VEDAMAAYU || patientDetail.type === "Walkin") && (
                        <MenuItem value="Walkin">Walk In</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                  <FormControl class="input" style={{ marginLeft: "10px" }}>
                    <Select
                      name="department"
                      value={patientDetail.department || ""}
                      onChange={(event) =>
                        handleInputChange("department", event.target.value)
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select Department
                      </MenuItem>
                      {department.map((dept) => (
                        <MenuItem key={dept.id} value={dept.id}>
                          {dept.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl class="input" style={{ marginLeft: "10px" }}>
                    <Autocomplete
                      freeSolo
                      options={docList.map((d) => ({
                        id: d.id,
                        label: d.label,
                      }))}
                      getOptionLabel={(option) => {
                        // When option is a string (typing)
                        if (typeof option === "string") return option;

                        // When option is an object (doctor)
                        return option.label || "";
                      }}
                      value={patientDetail.visit.reference.refby || ""}
                      onChange={(e, value) => {
                        // 'value' can be string (custom) or object (selected doctor)
                        if (typeof value === "string") {
                          {
                            console.log("value", value);
                          }
                          handleInputChange("reference", value);
                        } else if (value && value.id) {
                          handleInputChange("reference", value);
                          {
                            console.log("value", value);
                          }
                        } else {
                          handleInputChange("reference", "");
                        }
                      }}
                      onInputChange={(e, value) => {
                        // always capture typed text too
                        handleInputChange("reference", value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Reference"
                          variant="outlined"
                          size="small"
                          style={{ width: 250 }}
                          InputLabelProps={{
                            style: {
                              color: "rgba(0, 0, 0, 0.87)",
                              fontWeight: 400,
                            },
                          }}
                        />
                      )}
                    />
                  </FormControl>
                  <IconButton
                    className="cpointer"
                    aria-label="close"
                    onClick={closeProfileEdit}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
            </DialogTitle>

            <DialogContent
              className="ad-app-informationContent"
              style={{ overflowY: "auto", height: "fit-content" }}
            >
              <div>
                <Grid
                  container
                  className="patient-edit-form ad-app-informationContent"
                >
                  <Box style={{ fontSize: "14px", width: "100%" }}>
                    <Grid container spacing={2} className="padding1">
                      {patientDetail.type === "InPatient" ||
                      patientDetail.type === "Walkin" ? (
                        //   <Col md="4" className="form-group">
                        //   <label htmlFor="birthdetails">Admission Date</label>
                        //   <input
                        //     name="admissionDate"
                        //     id="admissionDate"
                        //     className="form-control filterin Quantity"
                        //     placeholder="Enter Scheduled Date"
                        //     required
                        //     type="date"
                        //     defaultValue={selecteddate}
                        //     onChange={(event)=>handleOnChange("date",event)}
                        // />
                        //   </Col>

                        <Grid item md={4}>
                          <label htmlFor="birthdetails">Admission Date</label>
                          <TextField
                            name="admissionDate"
                            id="admissionDate"
                            className="form-control filterin Quantity"
                            placeholder="Enter Scheduled Date"
                            autoComplete="off"
                            type="date"
                            defaultValue={selecteddate}
                            onChange={(event) => handleOnChange("date", event)}
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              style: { height: "35px" },
                            }}
                          />
                        </Grid>
                      ) : (
                        ""
                      )}

                      {patientDetail.type === "InPatient" ||
                      patientDetail.type === "Walkin" ? (
                        //     <Col md="4" className="form-group">
                        //     <label htmlFor="birthdetails">Admission Time</label>
                        //     <input
                        //   name="admissionTime"
                        //   id="admissionTime"
                        //   className="form-control filterin Quantity"
                        //   placeholder="Enter Scheduled Time"
                        //   required
                        //   type="time"
                        //   defaultValue={selectedTime}
                        //   onChange={(event)=>handleOnChange("time",event)}
                        // />
                        //     </Col>

                        <Grid item md={4}>
                          <label htmlFor="birthdetails">Admission Time</label>
                          <TextField
                            name="admissionTime"
                            id="admissionTime"
                            className="form-control filterin Quantity"
                            placeholder="Enter Scheduled Time"
                            autoComplete="off"
                            type="time"
                            defaultValue={selectedTime}
                            onChange={(event) => handleOnChange("time", event)}
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              style: { height: "35px" },
                            }}
                          />
                        </Grid>
                      ) : (
                        ""
                      )}
                      {patientDetail.type === "InPatient" ||
                      patientDetail.type === "Walkin" ? (
                        <Grid item md={4}></Grid>
                      ) : (
                        ""
                      )}
                      <Grid item md={4}>
                        {/* <label htmlFor="fname">First Name <span className='text-danger'>*</span></label> */}

                        <TextField
                          className="p-2"
                          label="First Name"
                          id="fname"
                          value={patientDetail.fname}
                          placeholder="First Name"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("fname", event.target.value)
                          }
                          error={formErrors.fname !== ""}
                          helperText={
                            <span style={{ color: "#EC4147" }}>
                              {formErrors.fname}
                            </span>
                          }
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>
                      <Grid item md={4}>
                        {/* <label htmlFor="mname">Middle Name</label> */}
                        <TextField
                          className="p-2"
                          label="Middle Name"
                          id="mname"
                          value={patientDetail.mname}
                          placeholder="Middle Name"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("mname", event.target.value)
                          }
                          // variant="outlined"
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>
                      <Grid item md={4}>
                        {/* <label htmlFor="lname">Last Name</label> */}
                        <TextField
                          className="p-2"
                          label="Last Name"
                          id="lname"
                          value={patientDetail.lname}
                          placeholder="Last Name"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("lname", event.target.value)
                          }
                          // variant="outlined"
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      spacing={2}
                      className="d-flex justify-content-between padding1"
                    >
                      <Grid item md={4}>
                        {/* <label htmlFor="phno">Phone Number <span className='text-danger'>*</span></label> */}
                        <TextField
                          className="p-2"
                          label="Phone Number"
                          id="phno"
                          type="number"
                          value={patientDetail.phno}
                          placeholder="Phone Number"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("phno", event.target.value)
                          }
                          onKeyDown={handleKeyDown}
                          error={formErrors.phno !== ""}
                          helperText={
                            <span style={{ color: "#EC4147" }}>
                              {formErrors.phno}
                            </span>
                          }
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>

                      <Grid item md={4}>
                        {/* <label htmlFor="age">Age <span className='text-danger'>*</span></label> */}
                        <TextField
                          className="p-2"
                          label="Age"
                          type="number"
                          id="age"
                          min={0}
                          value={patientDetail.age}
                          placeholder="Age"
                          autoComplete="off"
                          onChange={(event) =>
                            handleInputChange("age", event.target.value)
                          }
                          onKeyDown={handleKeyDown}
                          error={formErrors.age !== ""}
                          helperText={
                            <span style={{ color: "#EC4147" }}>
                              {formErrors.age}
                            </span>
                          }
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>

                      <Grid item md={4}>
                        <label htmlFor="gender">
                          Gender <span className="text-danger">*</span>
                        </label>
                        <RadioGroup
                          className="radioGroup"
                          row
                          aria-label="gender"
                          name="gender"
                          value={selectedGender}
                          onChange={(event) =>
                            onSelectedGender(event.target.value)
                          }
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        >
                          <FormControlLabel
                            value="Male"
                            className="radioMale"
                            control={
                              <Radio
                                inputRef={(el) => (radioRefs.current[0] = el)}
                                onKeyDown={(e) => {
                                  handleRadioKeyDown(e, 0);

                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    e.target.click(); // <-- ensures UI selection happens
                                  }
                                }}
                              />
                            }
                            label="Male"
                          />

                          <FormControlLabel
                            value="Female"
                            className="radioMale"
                            control={
                              <Radio
                                inputRef={(el) => (radioRefs.current[1] = el)}
                                onKeyDown={(e) => {
                                  handleRadioKeyDown(e, 1);

                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    e.target.click();
                                  }
                                }}
                              />
                            }
                            label="Female"
                          />

                          <FormControlLabel
                            value="Others"
                            className="radioMale"
                            control={
                              <Radio
                                inputRef={(el) => (radioRefs.current[2] = el)}
                                onKeyDown={(e) => {
                                  handleRadioKeyDown(e, 2);

                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    e.target.click();
                                  }
                                }}
                              />
                            }
                            label="Others"
                          />
                        </RadioGroup>
                        <div style={{ color: "#EC4147" }}>
                          <span>{formErrors.gender}</span>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} className="padding1">
                      <Grid item md={4}>
                        {/* <label htmlFor="Adhar">
                      Aadhar<span className='text-danger'>*</span>
                      </label> */}
                        <TextField
                          className="p-2"
                          label={
                            isAadhaarMandatoryForOnboarding(
                              org,
                              patientDetail.type,
                            ) && props.type !== "adminAppoinment" ? (
                              <span>
                                Aadhaar{" "}
                                <span style={{ color: "var(--bs-danger)" }}>
                                  *
                                </span>
                              </span>
                            ) : (
                              "Aadhaar"
                            )
                          }
                          id="Adhar"
                          type="number"
                          inputProps={{
                            min: "0",
                            max: "999999999999",
                          }}
                          value={patientDetail.adhar}
                          placeholder="000011112222"
                          autoComplete="off"
                          onChange={(event) => {
                            handleInputChange("adhar", event.target.value);
                          }}
                          onKeyDown={handleKeyDown}
                          error={formErrors.adhar !== ""}
                          helperText={formErrors.adhar}
                          fullWidth
                          InputProps={{
                            style: { height: "35px" },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </div>
              <Dialog
                className="showWebCamModal"
                open={showWebCamModal}
                onClose={toggleModal}
              >
                <DialogTitle>
                  <div class="dialogCloseIcon">
                    Capture Patient Image
                    <IconButton
                      className="cpointer"
                      aria-label="close"
                      onClick={toggleModal}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <Card className="card1">
                    {showWebCam === false ? (
                      <CardBody>
                        {selectedOption === "selfie" ? (
                          <Webcam
                            audio={false}
                            imageSmoothing={true}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            height={`250px`}
                            width={`350px`}
                            videoConstraints={videoConstraintsSelfie}
                          />
                        ) : (
                          <Webcam
                            audio={false}
                            imageSmoothing={true}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            height={`100px`}
                            width={`100px`}
                            videoConstraints={videoConstraints}
                          />
                        )}
                        <div>
                          <Button
                            className="buttOnMui"
                            variant="contained"
                            color="primary"
                            onClick={capture}
                            style={{ textTransform: "none" }}
                          >
                            Capture
                          </Button>
                        </div>
                      </CardBody>
                    ) : (
                      <>
                        {imgSrc && (
                          <>
                            <CardImg src={imgSrc} />
                            <CardBody>
                              <Button
                                className="buttOnMui"
                                variant="contained"
                                color="primary"
                                onClick={onImageSubmit}
                                style={{ textTransform: "none" }}
                              >
                                Save Image
                              </Button>
                              <Button
                                className="buttOnMui"
                                variant="contained"
                                color="primary"
                                onClick={onFileCancel}
                                style={{
                                  textTransform: "none",
                                  float: `right`,
                                }}
                              >
                                Cancel
                              </Button>
                            </CardBody>
                          </>
                        )}
                      </>
                    )}
                  </Card>
                </DialogContent>
                <DialogActions>
                  <Button
                    className="buttOnMui"
                    variant="contained"
                    color="primary"
                    onClick={toggleModal}
                    style={{ textTransform: "none" }}
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            </DialogContent>

            <DialogActions
              className="buttonNext"
              style={{ position: "sticky", bottom: 0, backgroundColor: "#fff" }}
            >
              <Button
                className="buttOnMui"
                variant="contained"
                color="primary"
                onClick={(event) => handleSubmit(event)}
                style={{ textTransform: "none" }}
              >
                {callType && callType === "Add" ? "Next" : "Submit"}
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      )}
    </main>
  );
}

/* function mapStateToProps(state) {
  return {
    patient:state.patientDetailsState.patient
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addPatient: (data, resCb) => dispatch(patientActions.addPatient(data, resCb)),
    updatePatient: (data, resCb) => dispatch(patientActions.updatePatient(data, resCb)),
  };
}

const PatientFormWithProps = connect(mapStateToProps, mapDispatchToProps)(PatientForm); */

export default PatientForm;
